// extracted by mini-css-extract-plugin
export var badge = "_gy-2";
export var detailsPanel = "_gy-0";
export var resultRow = "_gy-1";